import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CreateLeadService {

	constructor(private ws: PostmethodService) { }

createLead (request: any) {
  return this.ws.wsPost(request, environment.baseUrl + "/lead/createLead");
}

sendOtp(request: any) {
  return this.ws.wsPost(request, environment.baseUrl + "/lead/sendWhatsappOtp");
}

verifyOtp(request: any) {
  return this.ws.wsPost(request, environment.baseUrl + "/lead/getVerifyOtp");
}

}
